import type { CSSProperties, InputHTMLAttributes } from "react";
import { forwardRef, useId, useImperativeHandle, useRef } from "react";
import { getColor } from "../../../scss";
import styles from "./checkbox.module.scss";

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  color?: string;
  indeterminate?: boolean;
}

const Checkbox = forwardRef((props: CheckboxProps, ref) => {
  const {
    color = getColor("primary-600"),
    label,
    className,
    size,
    ...inputProps
  } = props;
  const checkboxRef = useRef(null);
  const checkboxId = inputProps?.id ? inputProps?.id : useId();
  useImperativeHandle(ref, () => ({}));

  return (
    <div style={{ "--color": color } as CSSProperties} className={className}>
      <input
        className={styles["checkbox"]}
        ref={checkboxRef}
        id={checkboxId}
        {...inputProps}
        type="checkbox"
      />
      <label htmlFor={checkboxId}>
        {inputProps.indeterminate ? (
          <svg
            width={size || "16"}
            height={size || "17"}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3333 0.5H2.66667C1.95942 0.5 1.28115 0.780952 0.781049 1.28105C0.280952 1.78115 0 2.45942 0 3.16667V13.8333C0 14.5406 0.280952 15.2189 0.781049 15.719C1.28115 16.219 1.95942 16.5 2.66667 16.5H13.3333C14.0406 16.5 14.7189 16.219 15.219 15.719C15.719 15.2189 16 14.5406 16 13.8333V3.16667C16 2.45942 15.719 1.78115 15.219 1.28105C14.7189 0.780952 14.0406 0.5 13.3333 0.5ZM10.6667 9.38889H5.33333C5.09759 9.38889 4.87149 9.29524 4.70479 9.12854C4.53809 8.96184 4.44444 8.73575 4.44444 8.5C4.44444 8.26425 4.53809 8.03816 4.70479 7.87146C4.87149 7.70476 5.09759 7.61111 5.33333 7.61111H10.6667C10.9024 7.61111 11.1285 7.70476 11.2952 7.87146C11.4619 8.03816 11.5556 8.26425 11.5556 8.5C11.5556 8.73575 11.4619 8.96184 11.2952 9.12854C11.1285 9.29524 10.9024 9.38889 10.6667 9.38889Z"
              fill="#FF6A00"
            />
          </svg>
        ) : inputProps.checked ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || "16"}
            height={size || "16"}
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
              fill={color}
            />
            <path
              d="M11 6L6.62257 10L5 8.4568"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || "16"}
            height={size || "16"}
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z"
              stroke="#667085"
            />
          </svg>
        )}
        {label}
      </label>
    </div>
  );
});

export default Checkbox;
